import {
    Checkbox,
    FormControlLabel,
    FormGroup
} from "@mui/material";

import { IssueStatus } from "../../../models";
import { issueStatusText } from "../issuesStatusText";

interface StatusFilterProps {
    statusFilterState: Map<IssueStatus, boolean>;
    onStatusFilterChange: (status: IssueStatus, isChecked: boolean) => void;
}

export const StatusFilter = (props: StatusFilterProps) => {
    const { statusFilterState, onStatusFilterChange } = props;

    return (
        <FormGroup>
            {Object.values(IssueStatus).map((status) => (
                <FormControlLabel
                    key={`status-${status}`}
                    control={
                        <Checkbox
                            size="small"
                            onChange={(event, isChecked) => onStatusFilterChange(status, isChecked)}
                            checked={statusFilterState.get(status)}
                        />
                    }
                    label={issueStatusText[status]}
                />
            ))}
        </FormGroup>
    );
};
